import { useContext } from 'react';
import { TextButton } from '@zillow/constellation-10';
import { LeadManagementContext } from '../../../../contexts/LeadManagementContextProvider';
import useQueryParamsNext from '../../../../hooks/useQueryParamsNext';
import { FULLSTORY_EXCLUDE_CLASS_NAME } from '@zg-rentals/satellite-components';

type LeadNameButtonProps = {
  conversationId: string;
  // The shared phone-lead label, not a name — skips the capitalize transform.
  isPhoneLeadLabel?: boolean;
  leadName: string;
};

export default function LeadNameButton({ conversationId, isPhoneLeadLabel, leadName }: LeadNameButtonProps) {
  const { isArchivedFolder, isReportedFolder } = useContext(LeadManagementContext);
  const { updateQueryParams } = useQueryParamsNext();

  const handleLeadNameClick = () => {
    updateQueryParams({
      queryParamValues: {
        conversationId,
      },
      shouldReplaceHistory: true,
    });
  };

  return (
    <TextButton
      className={FULLSTORY_EXCLUDE_CLASS_NAME}
      css={{ textTransform: isPhoneLeadLabel ? 'none' : 'capitalize' }}
      disabled={isArchivedFolder || isReportedFolder}
      id="lead-name"
      onClick={handleLeadNameClick}
      textStyle="body"
      tone="neutral"
    >
      {leadName}
    </TextButton>
  );
}
